import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './pages/App.vue'
import Form from './pages/Form.vue'
import Video from './pages/Video.vue'
import VideoOld from './pages/Video_old.vue'
import Root from './Root.vue'
// import Image from './pages/Image.vue'
import Redirect from './pages/Redirect.vue'

const routes = [
    { path: '/app', component: App, name: "app"},
    { path: '/form', component: Form, name: "form"},
    { path: '/video/:campaignId', component: Video, name: "video"},
    { path: '/video-old/:campaign', component: VideoOld, name: "video-old"},
    // { path: '/image/:campaign', component: Image, name: "image"},
    { path: '/', component: Root},
    { path: '/redirect/:campaignId', component: Redirect},
    { path: '/ii', redirect: '/app'},
]

const router = createRouter({
    history: createWebHistory(),
    base: '/',
    routes: routes,
})

let app = createApp(Root)
app.use(router)
app.mount('#app')

